import type { FC } from 'react'

import { isStories } from '@core/params/helpers/isStories'
import { type EmbedFeedParams, WidgetSizeEnum } from '@core/types'
import type { IWidgetState } from '@core/widgets/store'
import { GRID_PLACEHOLDERS_WRAPPER } from '@player/testIds'

import { PlayerDeckPlaceholder } from './PlayerDeckContainer/PlayerDeckPlaceholder'
import { Grid, GridInner, GridWrapper } from './GridComponent.styles'
import Placeholder from './Placeholder'

interface Props {
  columns: number
  largeCarousel: boolean
  params: EmbedFeedParams
  placeholders: IWidgetState['placeholders']
  responsive?: boolean
  columnWidth?: string
}

/**
 * Grid's placeholders rendered while videos are loading.
 */
export const GridPlaceholders: FC<Props> = ({
  columns,
  largeCarousel,
  params,
  placeholders,
  responsive = false,
  columnWidth,
}) => {
  return (
    <GridWrapper
      borderStyle={params.ui_border_style}
      data-testid={GRID_PLACEHOLDERS_WRAPPER}
    >
      <GridInner>
        <Grid
          columns={columns}
          gridMode={params.mode}
          isStoriesLayout={isStories(params)}
          pulseAnimation={params.pulse_animation}
          widgetSize={params.size}
        >
          {placeholders.map((_, i) =>
            params.player_deck_layout ? (
              <PlayerDeckPlaceholder
                key={i}
                params={params}
                responsive={responsive}
                columnWidth={columnWidth}
              />
            ) : (
              <Placeholder
                isLarge={largeCarousel}
                key={i}
                mode={params.mode}
                isSmall={params.size === WidgetSizeEnum.SMALL}
              />
            ),
          )}
        </Grid>
      </GridInner>
    </GridWrapper>
  )
}
